
import type { PropOptions } from 'vue';
import Vue from 'vue';
import LogoSvg from './images/logo.vue.svg';

export default Vue.extend({
  name: 'BravadoTypeformLeft',
  components: {
    LogoSvg,
  },
  props: {
    title: {
      type: String,
      required: true,
    } as PropOptions<string>,
    description: {
      type: String,
      required: true,
    } as PropOptions<string>,
    image: {
      type: Function,
      default: () => '',
    } as PropOptions<<T>(val: T) => T>,
    imageDesc: {
      type: String,
      required: true,
    } as PropOptions<string>,
    imageScale: {
      type: String,
      default: 'sm',
      validator(value: string): boolean {
        return ['md', 'sm', 'auto'].includes(value);
      },
    } as PropOptions<string>,
    showImage: {
      type: Boolean,
      default: false,
    } as PropOptions<boolean>,
  },
  computed: {
    rootClasses(): Record<string, boolean> {
      return {
        'bravado-typeform-left': true,
        'bravado-typeform-left--with-image': this.showImage,
      };
    },
    imageScaleClasses(): Record<string, boolean> {
      return {
        'bravado-typeform-left__image-scale': true,
        [`bravado-typeform-left__image-scale--${this.imageScale}`]: true,
      };
    },
  },
});
